var _ellipse, _circle, _ellipse2, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0008,
    cy: 10.999,
    rx: 11.0008,
    ry: 10.999,
    transform: "matrix(1 -0.000604159 0.000488337 1 0 0.0136719)",
    fill: "#F9EDDB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.66667,
    cy: 3.66667,
    r: 3.66667,
    transform: "matrix(1 -0.000604159 0.000488337 1 7.33594 6.42578)",
    fill: "#C1022F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_575_57338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.001,
    cy: 10.9987,
    rx: 11.001,
    ry: 10.9987,
    transform: "matrix(1 -0.000674667 0.000445294 1 0 0.015625)",
    fill: "#73BEE2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_575_57338)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.33399,
    cy: 7.33248,
    rx: 7.33399,
    ry: 7.33248,
    transform: "matrix(1 -0.000674667 0.000445294 1 3.67578 14.6797)",
    fill: "#C1022F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0106 20.0051C15.982 20.002 20.0095 15.9703 20.0071 11.0006C20.0046 6.0309 15.9732 2.00402 11.0018 2.00703C6.03048 2.01003 2.00294 6.04177 2.00537 11.0115C2.0078 15.9812 6.03927 20.0081 11.0106 20.0051ZM11.0116 22.0051C17.0872 22.0014 22.01 17.074 22.0071 10.9994C22.0041 4.9248 17.0764 0.00335499 11.0008 0.00702561C4.92525 0.0106962 0.00240478 4.9381 0.00537123 11.0127C0.00833768 17.0873 4.93599 22.0087 11.0116 22.0051Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.a02d3c670e05e55491404a80bdd98011.svg";
export { ForwardRef as ReactComponent };